import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
	registrationSlice,
	userSlice,
	overviewSlice,
	settingsSlice,
	authorizationSlice,
	verify2FASlice,
	fundingSlice,
	userSettingsSlice,
	forgotPasswordSlice,
	statementSlice,
	myInvestmentsSlice,
	primaryMarketSlice,
	cookiesSlice,
	questionnaireSlice,
	secondaryMarketSlice,
	newsSlice,
} from 'features';

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['registration', 'cookies'],
	blacklist: ['authorization', 'verify2FA', 'forgotPassword', 'primaryMarket', 'user'],
};

const reducer = persistReducer(
	persistConfig,
	combineReducers({
		authorization: authorizationSlice,
		registration: registrationSlice,
		user: userSlice,
		overview: overviewSlice,
		settings: settingsSlice,
		verify2FA: verify2FASlice,
		funding: fundingSlice,
		userSettings: userSettingsSlice,
		forgotPassword: forgotPasswordSlice,
		statement: statementSlice,
		myInvestments: myInvestmentsSlice,
		primaryMarket: primaryMarketSlice,
		cookies: cookiesSlice,
		questionnaire: questionnaireSlice,
		secondaryMarket: secondaryMarketSlice,
		news: newsSlice,
	}),
);

export const store = configureStore({
	reducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export type AppDispatch = typeof store.dispatch;
export type AppSelector = ReturnType<typeof store.getState>;

export const persistor = persistStore(store);
